import { adminClient, apiKeyClient, magicLinkClient, passkeyClient } from "better-auth/client/plugins";

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  plugins: [passkeyClient(), adminClient(), apiKeyClient(), magicLinkClient()],
});
